import { Controller } from "@hotwired/stimulus";

export class ApplicantSelectionController extends Controller {
  static targets = ["bulkActionsBar", "selectAllCheckbox", "selectedCount"];
  static values = {
    bulkDeleteUrl: String,
    vacancyId: String,
  };

  connect() {
    this.selectedIds = new Set();
    this.updateBulkActionsVisibility();

    this._onHtmxAfterSwap = this._onHtmxAfterSwap.bind(this);
    document.body.addEventListener("htmx:afterSwap", this._onHtmxAfterSwap);
  }

  disconnect() {
    document.body.removeEventListener("htmx:afterSwap", this._onHtmxAfterSwap);
  }

  _onHtmxAfterSwap(event) {
    if (event.detail.target.id !== "applicant-list-container") return;

    this.selectedIds.clear();
    this.updateBulkActionsVisibility();

    if (this.hasSelectAllCheckboxTarget) {
      this.selectAllCheckboxTarget.checked = false;
      this.selectAllCheckboxTarget.indeterminate = false;
    }
  }

  toggleRow(event) {
    const checkbox = event.currentTarget;
    const id = checkbox.value;

    if (checkbox.checked) {
      this.selectedIds.add(id);
    } else {
      this.selectedIds.delete(id);
    }

    this.updateBulkActionsVisibility();
    this.updateSelectAllState();
  }

  toggleAll(event) {
    const checkboxes = this.element.querySelectorAll(
      '#applicant-list-container input[name="application_ids"]',
    );
    const isChecked = event.currentTarget.checked;

    checkboxes.forEach((checkbox) => {
      checkbox.checked = isChecked;
      const id = checkbox.value;
      if (isChecked) {
        this.selectedIds.add(id);
      } else {
        this.selectedIds.delete(id);
      }
    });

    this.updateBulkActionsVisibility();
    this.updateSelectAllState();
  }

  updateBulkActionsVisibility() {
    if (this.selectedIds.size > 0) {
      this.bulkActionsBarTarget.classList.remove("hidden");
    } else {
      this.bulkActionsBarTarget.classList.add("hidden");
    }

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = `${this.selectedIds.size}`;
    }
  }

  updateSelectAllState() {
    if (!this.hasSelectAllCheckboxTarget) return;

    const checkboxes = this.element.querySelectorAll(
      '#applicant-list-container input[name="application_ids"]',
    );
    const checkedCount = Array.from(checkboxes).filter(
      (cb) => cb.checked,
    ).length;

    if (checkedCount === 0) {
      this.selectAllCheckboxTarget.checked = false;
      this.selectAllCheckboxTarget.indeterminate = false;
    } else if (checkedCount === checkboxes.length) {
      this.selectAllCheckboxTarget.checked = true;
      this.selectAllCheckboxTarget.indeterminate = false;
    } else {
      this.selectAllCheckboxTarget.checked = false;
      this.selectAllCheckboxTarget.indeterminate = true;
    }
  }
}
